import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const FormsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Forms",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M3.51 30h10.34c.83 0 1.5-.67 1.5-1.51V23.5c0-.83-.67-1.5-1.5-1.5H3.51c-.83 0-1.5.67-1.5 1.51v4.99c0 .83.67 1.5 1.5 1.5m1.5-4.99h7.34v2H5.01zm-1.5-5H28.5c.83 0 1.5-.67 1.51-1.49v-5.01c0-.83-.67-1.5-1.51-1.5h-25c-.83 0-1.5.67-1.5 1.5v4.99c0 .83.67 1.5 1.5 1.5Zm1.5-4.99h21.98v1.99H5.01zm-1.5-5H28.5c.83 0 1.5-.67 1.51-1.49V3.51c0-.83-.67-1.5-1.51-1.5h-25c-.83 0-1.5.67-1.5 1.5v5C2 9.34 2.68 10 3.5 10Zm1.5-4.99h21.98v1.99H5.01zm13.15 16.99h10.33c.83 0 1.51.67 1.51 1.51v4.98c0 .83-.67 1.51-1.51 1.51H18.16a1.5 1.5 0 0 1-1.5-1.51v-4.98c0-.83.67-1.51 1.5-1.51"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.14 9.86H3c-.63 0-1.14-.51-1.14-1.14V3c0-.63.51-1.14 1.14-1.14h25.14c.63 0 1.14.51 1.14 1.14v5.71c0 .63-.51 1.14-1.14 1.14Zm-24-2.29H27V4.14H4.14zM28.14 20.14H3c-.63 0-1.14-.51-1.14-1.14v-5.71c0-.63.51-1.14 1.14-1.14h25.14c.63 0 1.14.51 1.14 1.14V19c0 .63-.51 1.14-1.14 1.14m-24-2.28H27v-3.43H4.14zM13.29 29.29H3c-.63 0-1.14-.51-1.14-1.14v-4.57c0-.63.51-1.14 1.14-1.14h10.29c.63 0 1.14.51 1.14 1.14v4.57c0 .63-.51 1.14-1.14 1.14M4.14 27h8v-2.29h-8zM28.14 29.29H17.85c-.63 0-1.14-.51-1.14-1.14v-4.57c0-.63.51-1.14 1.14-1.14h10.29c.63 0 1.14.51 1.14 1.14v4.57c0 .63-.51 1.14-1.14 1.14M19 27h8v-2.29h-8z"
      })
    })
  }));
};
FormsIcon.displayName = 'FormsIcon';